<div class="collapsible-area">
  <div class="header noselect" (click)="toggle()">
    <span class="title">{{title}}</span>
    <nb-icon [icon]="icon" pack="eva" [nbTooltip]="tooltip"></nb-icon>
  </div>
  <div class="content" [class.visible]="expanded">
    <ng-content></ng-content>
  </div>
</div>
